import { render } from "./McTooltip.vue?vue&type=template&id=58676297&scoped=true"
import script from "./McTooltip.vue?vue&type=script&lang=js"
export * from "./McTooltip.vue?vue&type=script&lang=js"

import "./McTooltip.vue?vue&type=style&index=0&id=58676297&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58676297"]])

export default __exports__